import Immutable from 'immutable';
import {
  CLEAR_CHART_OF_ACCOUNTS,
  FLAG_GETTING_CHART_OF_ACCOUNTS,
  GET_CHART_OF_ACCOUNTS,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.List(), 
    loading: false,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_CHART_OF_ACCOUNTS:
      return state.setIn(['all', 'loading'], action.payload);

    case GET_CHART_OF_ACCOUNTS:
      return state.setIn(['all', 'content'], Immutable.fromJS(action.payload));

    case CLEAR_CHART_OF_ACCOUNTS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );

    default:
      return state;
  }
};